export const getPanelTransitionProps = (onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate) => ({
  onOpenStart,
  onOpenComplete,
  onCloseStart,
  onCloseComplete,
  align,
  duration: animate ? undefined : 0
});